import PageBanner from "../components/ui/PageBanner";
import "./About.css";
import ministryMeetingImg from "../assets/news-ministry-1.jpeg";
import ministryDiscussionImg from "../assets/news-ministry-2.jpeg";

export default function NewsEvents({ setPage }) {
  return (
    <div className="about-page">
      <PageBanner title="News & Events" crumbs={["Home", "About", "News & Events"]} />

      <section className="section">
        <div className="section-inner">
          <div className="about__section-head">
            <p className="section-label">Events &amp; Health Camps</p>
            <h3 className="section-title">Stay updated with our health awareness programs and community events</h3>
            <p className="section-text">
              Capital Care International Hospital regularly organizes health awareness programs, free medical camps, and
              educational seminars to serve the community and promote health awareness.
            </p>
          </div>

          <div className="about__feature card">
            <div className="about__feature-copy">
              <p className="section-label">Latest News</p>
              <h3 className="section-title">
                Capital Diagnostic Centre &amp; Capital Care International Hospital Represent Healthcare Excellence at
                Ministry of Health
              </h3>
              <p className="section-text">
                Capital Diagnostic Centre (CDC) and Capital Care International Hospital (CCIH) proudly participated in
                a high-level meeting at the Ministry of National Health Services, reaffirming their commitment to
                healthcare excellence, innovation, and quality patient care. The engagement reflects our continued
                dedication to strengthening Pakistan&apos;s healthcare system through collaboration, advanced medical
                services, and patient-centered care.
              </p>
            </div>

            <div className="about__feature-gallery">
              <img
                className="about__feature-image"
                src={ministryMeetingImg}
                alt="Capital Diagnostic Centre and Capital Care International Hospital meeting at the Ministry of Health"
                loading="lazy"
              />
              <img
                className="about__feature-image"
                src={ministryDiscussionImg}
                alt="CDC and CCIH representatives in discussion at the Ministry of Health"
                loading="lazy"
              />
            </div>
          </div>

          <div className="about__cards-grid">
            <div className="card" style={{ padding: 18 }}>
              <h3 className="section-title" style={{ marginBottom: 8 }}>
                Upcoming Events
              </h3>
              <p className="section-text" style={{ marginBottom: 0 }}>
                We conduct regular health screening camps, vaccination drives, and awareness sessions on various health
                topics including diabetes management, heart health, and preventive care.
              </p>
            </div>

            <div className="card" style={{ padding: 18 }}>
              <h3 className="section-title" style={{ marginBottom: 8 }}>
                What To Expect
              </h3>
              <ul style={{ margin: 0, paddingLeft: 18, color: "var(--subtext)", lineHeight: 1.8, fontSize: 14 }}>
                <li>Free/low-cost screening camps</li>
                <li>Health education &amp; awareness sessions</li>
                <li>Community outreach and referrals</li>
              </ul>
            </div>

            <div className="card" style={{ padding: 18 }}>
              <h3 className="section-title" style={{ marginBottom: 8 }}>
                Stay Updated
              </h3>
              <p className="section-text" style={{ marginBottom: 0 }}>
                Follow our social media channels or contact us to stay updated about upcoming events and health camps in
                your area.
              </p>
            </div>
          </div>

          <div className="about__actions">
            <button type="button" className="btn-primary" onClick={() => setPage?.("contact")}>
              Contact Us
            </button>
            <button type="button" className="btn-outline" onClick={() => setPage?.("home")}>
              Back to Home
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
